module.exports = __webpack_public_path__ + "frontend-assets/img/card-code.a77cc57c.png";